import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';

import {getBoundExternalParticipants, unbindExternalParticipant} from '../api';
import {QUERY__PARTICIPANTS} from '../queryKeys';

const queryKey = (participantId: string) => [
  QUERY__PARTICIPANTS,
  participantId,
  'external',
];

export const useGetBoundExternalParticipants = (participantId: string) => {
  return useQuery({
    queryKey: queryKey(participantId),
    queryFn: () => getBoundExternalParticipants(participantId),
    enabled: !!participantId,
  });
};

export const useUnbindExternalParticipant = (participantId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (externalParticipantId: string) =>
      unbindExternalParticipant(participantId, externalParticipantId),
    onSuccess: () => {
      void queryClient.invalidateQueries({queryKey: queryKey(participantId)});
    },
  });
};
